var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinusCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1e284d",
  d: "M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0M4.677 11.613a.485.485 0 0 1-.484-.484V8.871a.485.485 0 0 1 .484-.484h10.646a.485.485 0 0 1 .484.484v2.258a.485.485 0 0 1-.484.484Z"
})));
export default SvgMinusCircle;